import { render, staticRenderFns } from "./Stuhrversum.vue?vue&type=template&id=79b15f18&scoped=true&"
import script from "./Stuhrversum.vue?vue&type=script&lang=js&"
export * from "./Stuhrversum.vue?vue&type=script&lang=js&"
import style0 from "./Stuhrversum.vue?vue&type=style&index=0&id=79b15f18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b15f18",
  null
  
)

export default component.exports